import { t } from 'i18next';

import { Badge } from '@/components/ui/badge';
import { ADVANCED_PIECE_NAMES } from '@activepieces/shared';

// Shown only on the exception: no badge means the piece is on every plan.
export const PieceBusinessBadge = ({ pieceName }: { pieceName: string }) =>
  ADVANCED_PIECE_NAMES.has(pieceName) ? (
    <Badge variant="outline" className="shrink-0">
      {t('Business')}
    </Badge>
  ) : null;
